module.exports = __webpack_public_path__ + "img/facebook_login.7d48a94c.svg";